<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-content">
            <settings-form scope="server" :scope_id="serverId" :disabled-settings="disabledSettings"></settings-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import VueTabs from 'vue-nav-tabs'
import SettingsForm from "../Partials/SettingsForm";

Vue.use(VueTabs)
export default {
  components: {SettingsForm},
  mounted () {
    this.serverId = this.$route.params.id;
  },
  data () {
    return {
      serverId: '',
      activeName: 'first',
      disabledSettings: ['server.periodicity.minute']
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Servers/View.vue